module.exports = __webpack_public_path__ + "img/m15.fb218023.jpg";